export enum OrderItemTypeEnum {
  UNKNOWN = "unknown",
  WINE_BOTTLE = "wine-bottle",
}
